/* istanbul ignore file */
import { colorCSS, colorContrastCSS, colorExists, colorIsDark, gradientContrastCSS, gradientCSS, gradientExists, gradientIsDark } from './';
function isBackgroundFieldValue(value) {
    return !!value;
}
//background json could be { gradient: 'GR234' }
export function getColorsFromBackgroundField(background) {
    if (isBackgroundFieldValue(background)) {
        const { gradient, angle, color } = background;
        if (gradient && gradientExists(gradient)) {
            return {
                background: gradientCSS(gradient, angle),
                color: gradientContrastCSS(gradient),
                medium: gradientContrastCSS(gradient, 0.2),
                linkColor: gradientIsDark(gradient) ? colorCSS('N0', 0.8) : undefined,
                linkHoverColor: gradientIsDark(gradient) ? colorCSS('N0') : undefined
            };
        }
        else if (color && colorExists(color)) {
            return {
                background: colorCSS(color),
                color: colorContrastCSS(color),
                medium: colorContrastCSS(color, 0.2),
                linkColor: colorIsDark(color) ? colorCSS('N0', 0.8) : undefined,
                linkHoverColor: colorIsDark(color) ? colorCSS('N0') : undefined
            };
        }
    }
    return {};
}
//# sourceMappingURL=background.js.map